<script>
  import { createEventDispatcher } from 'svelte'
  import { HORIZON_FILTERS, HORIZON_LABELS } from '../lib/horizon.js'

  /** @type {'15m'|'5m'|'all'} */
  export let value = 'all'
  export let includeAll = true
  /** Optional aria label */
  export let label = 'Горизонт'

  const dispatch = createEventDispatcher()

  $: options = includeAll ? HORIZON_FILTERS : ['15m', '5m']

  function select(hz) {
    if (hz === value) return
    value = hz
    dispatch('change', hz)
  }
</script>

<div class="pm-hz" role="group" aria-label={label}>
  {#each options as hz}
    <button
      type="button"
      class="pm-hz__btn"
      class:is-on={value === hz}
      on:click={() => select(hz)}
    >
      {HORIZON_LABELS[hz] || hz}
    </button>
  {/each}
</div>
